<template lang="pug">
	.invite-company(v-if="companyInvite.visible && $auth.hasAccessToCompanyProfile()")
		dx-validation-group.flex-row.space-large.details-segment.wrap(ref="validationGroup")
			Popup(v-if="companyInvite.visible", :title="$tCaption('Company invitation')", :popupVisible.sync="companyInvite.visible", :width="400", :autosize="true")
				.flex-col.space-large
					.flex-col.field.space
						.font-small.upper.grey {{$tCaption('Name')}}
						dx-text-box(
							:value.sync="companyInvite.data.Name"
							width="100%"
							:disabled="companyInvite.processing",
							:input-attr="{ autocomplete: 'off' }"
						)
							dx-validator
								dx-required-rule(:message="$tCaption('Name is required')")
					.flex-col.field.space
						.font-small.upper.grey {{$tCaption('Email')}}
						dx-text-box(
							:value.sync="companyInvite.data.Email"
							width="100%"
							:disabled="companyInvite.processing"
						)
							dx-validator
								dx-required-rule(:message="$tCaption('Email is required')")
					template(v-if="companyInvite.data.CompanyType === 0 && $auth.isStationOwner()")
						DxCheckBox(:text="$tCaption('Invite for a brief')", :value.sync="inviteForABrief")
						.flex-col.field.space(v-if="inviteForABrief")
							.font-small.upper.grey {{$tCaption('Brief')}}
							Dropdown(:getTotal="(data) => data.TotalNumberOfRecords", :getItems="(data) => data.Results", :getData="getBriefs",
								:columns="[{ dataField: 'Name', caption: $tCaption('Company') }]", displayExpr="Name", valueExpr="Oid", v-model="briefId",
								:multiple="false")
								dx-validator
									dx-required-rule(:message="$tCaption('Brief is required')")
				.flex-row.space(slot="actions-right")
					DxButton(:text="$tCaption('Cancel', '@actions')", @click="companyInvite.visible = false")
					DxButton(:text="$tCaption('Send invite')", icon="email", type="default", @click="doSendCompanyInvite", :disabled="companyInvite.processing")
</template>

<script>
	import _ from 'lodash';
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxTextArea from 'devextreme-vue/text-area';
	import DxValidationGroup from 'devextreme-vue/validation-group';
	import DxValidator, { DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator';	
	import Popup from 'app-core/Popup.vue';
	import DxCheckBox from 'devextreme-vue/check-box';
	import Dropdown from 'app-core/Dropdown.vue';

	export default {
		translationCategory: 'company.InviteCompany',
		name: 'invite-company',
		components: {
			DxButton, DxTextBox, DxTextArea, DxValidationGroup, DxValidator, DxRequiredRule, DxCustomRule,
			Popup, DxCheckBox, Dropdown
		},		
		data() {
			return {
				companyInvite: {
					data: {
						Name: null,
						Email: null,
						AgencyID: null,
						AdvertiserCode: null,
						CompanyType: null
					},
					visible: false,
					processing: false
				},
				inviteForABrief: false,
				briefId: null
			};
		},
		mounted() {
			if (__DEBUG__)
				window.inviteCompany = this;
		},		
		methods: {
			getBriefs(pageIndex, limit, opts) {
				if (opts?.byKey) {
					return this.$Data.getExternalApi('Brief/GetBrief', `id=${opts.byKey}`).then(r => ({ Results: [r] }));
				}
				return this.$Data.getExternalApi('Brief/GetAllBriefs', `page=${pageIndex + 1}`, limit);
			},
			openCompanyInvite(data) {
				this.companyInvite.visible = false;
				this.inviteForABrief = false;
				_.assign(this.companyInvite.data, _.assign({
					Name: null,
					Email: null,
					AgencyID: null,
					AdvertiserCode: null,
					CompanyType: null
				}, data));
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.companyInvite.visible = true;
				});
			},
			doSendCompanyInvite(e) {
				if (!e.validationGroup.validate().isValid) {
					return;
				}
				if (this.inviteForABrief) {
					this.companyInvite.processing = true;
					this.$Data.postExternalApi('Brief/BriefInvite', {
						Name: this.companyInvite.data.Name,
						Email: this.companyInvite.data.Email,
						BriefId: this.briefId
					})
					.then((r) => {
						if (!r?.ErrorMessage) {
							this.$notifySuccess(this.$tCaption('Invitation successfully sent'));
						} else {
							this.$notifyError(r?.ErrorMessage);
						}
					})
					.finally(() => this.companyInvite.processing = false);
				} else {
					this.companyInvite.processing = true;
					this.$Data.postExternalApi('Company/CreateCompanyInvite', this.companyInvite.data).then(r => {
						if (__DEBUG__)
							console.log('Company invite created', { r });
						if (!r || r.Success !== false) {
							var msg = this.$tCaption('Company invite has been successfully created.');
							if (this.companyInvite.data.CompanyType === 0) {
								msg += ` ${this.$tCaption('The user will be invited once the advertiser has been approved.')}`;
							}
							this.$notifyMessage(msg);
							this.companyInvite.visible = false;
							this.$emit('sent', this.companyInvite.data);
						} else {
							this.$notifyError(r.ErrorMessage);
						}
					}).finally(() => this.companyInvite.processing = false);
				}
			}
		}
	};
</script>
<style lang='scss'>
	.invite-company {
	}
</style>
 